<template>
  <div class="loginPage">

    <img src="@/assets/images/login/login.jpg" class="loginBg">

    <div class="block">
      <van-icon name="arrow-left" size="28" color="#fff" @click="onClickLeft" class="backButton" />
      <div class="avatar-uploader">
        <div class="avatar"><img src="https://atest.xiaoaitt.com/Resource/Images/Default/Member.jpg"></div>
      </div>
      <div>
        <van-tabs v-model="tabActive" background="inherit" title-active-color="white" color="#fff">
          <van-tab title="密码登录">
            <div class="field-item">
              <div class="hd"><i class="fa fa-user"></i></div>
              <div class="bd"><van-field v-model.trim="inputText.username" placeholder="手机号/邮箱/天堂网账号" /></div>
            </div>
            <div class="field-item">
              <div class="hd"><i class="fa fa-lock"></i></div>
              <div class="bd"><van-field type="password" placeholder="密码" v-model.trim="inputText.password" /></div>
            </div>
          </van-tab>
          <van-tab title="验证码登录">
            <div class="field-item">
              <div class="hd"><i class="fa fa-user"></i></div>
              <div class="bd"><van-field v-model.trim="inputText.username" placeholder="手机号" /></div>
            </div>
            <div class="field-item">
              <div class="hd"><i class="fa fa-lock"></i></div>
              <div class="bd">
                <van-field type="text" v-model.trim="inputText.code" placeholder="请输入验证码" />
              </div>
              <div class="ft">
                <van-button @click="sendRegisterSmsCode" :disabled="disabled" slot="button" size="small" type="info">{{
                  downText }}</van-button>
              </div>
            </div>
          </van-tab>
        </van-tabs>
        <router-link to="/FindPwd" class="forgetbtn">忘记密码</router-link>
        <router-link style="float:right" to="/Register" class="forgetbtn">注册</router-link>
        <div class="btn-area">
          <van-button round @click="login" class="loginbtn">登录</van-button>
        </div>
        <div class="user-agreement">登录即同意<router-link to="/AgreementPage" class="hlight">用户协议</router-link>和<router-link
            to="/PrivacyPage" class="hlight">隐私政策</router-link></div>
        <van-divider :style="{ color: 'rgba(255,255,255,.8)', borderColor: 'rgba(255,255,255,.5)', padding: '0 16px' }">
          其他方式
        </van-divider>
        <div class="other-login">
          <div class="item">
            <img src="@/assets/images/login/qq.png">
          </div>
          <div class="item">
            <img src="@/assets/images/login/sina.png">
          </div>
          <div class="item">
            <img src="@/assets/images/login/weixin.png">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { Toast } from "vant";
import webconfig from '../../webconfig.config'
import { mapGetters } from 'vuex'
import common from "../../tools/common.js";

export default {
  data() {
    return {
      tabActive: 0,
      downText: "获取验证码",
      second: 60,
      disabled: false,
      inputText: {
        username: "",
        password: "",
        code: "",
        loginType: "",
        grant_type: webconfig.Grant_Type,
        appid: webconfig.Appid,
        secret: webconfig.Secret,
      }
    }
  },
  computed: {
    ...mapGetters(['currentToken'])
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    sendRegisterSmsCode() {
      var that = this;
      if (that.inputText.username == "") {
        that.$toast("手机号不能为空！");
        return false;
      }
      var myreg = /^[1][0-9]{10}$/;
      if (!myreg.test(that.inputText.username)) {
        that.$toast("请输入正确的手机号");
        return false;
      }
      // Object.assign(that.inputText, {
      //   type: "SendSmsCode"
      // });
      that.$store
        .dispatch({ type: "SendRegisterSmsCodeVue", phone: that.inputText.username })
        .then(res => {
          //console.log(res, "SendRegisterSmsCodeVue");
          common.countdowm(that, that.inputText.username, that.second);

        });
    },
    login() {
      var that = this;
      var returnUrl = this.$route.query.ReturnUrl;
      var params;
      if (that.inputText.username == "") {
        Toast("手机号/邮箱/天堂网账号不能为空！");
        return false;
      }
      if (that.tabActive == 0) {
        that.inputText.loginType = "ordinary";
        if (that.inputText.password == "") {
          Toast("密码不能为空！");
          return false;
        }
      }
      else {
        that.inputText.loginType = "phone";
        if (that.inputText.code == "") {
          that.$toast("验证码不能为空！");
          return false;
        }
      }
      params = that.inputText;
      Object.assign(params, {
        type: "Login"
      });
      that.$store.dispatch(params).then(res => {
        // console.log(res);
        if (res.error_description == "" || res.error_description == null) {
          if (returnUrl != null) {
            that.$router.replace(returnUrl);
          } else {
            that.$router.replace("/User");
          }
        } else {
          Toast(res.error_description);
        }
      });
    }
  },
  created() {
    // console.log(this.currentToken.isLogin)
    if (this.currentToken.isLogin) {
      this.$router.replace("/");
    }
  }
}
</script>

<style scoped>
.avatar-uploader {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 20%;
  margin-bottom: 8%;
}

.avatar-uploader .avatar {
  width: 105px;
  height: 105px;
  background: url('~@/assets/images/create/m_avatar_bg.png') center no-repeat;
  background-size: cover;
}

.avatar-uploader .avatar img {
  width: 100%;
  height: 100%;
  background-size: cover;
  padding: 10px;
  border-radius: 50%;
}
</style>
